function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var AudioPlayer = function AudioPlayer(audioElem, audioContext) {
  _classCallCheck(this, AudioPlayer);

  var audioCtx = audioContext.getAudioContext();
  var analyser = audioContext.getAnalyser();
  this.audioSource = audioCtx.createMediaElementSource(audioElem);
  this.audioSource.connect(analyser);
  analyser.connect(audioCtx.destination);
};

export { AudioPlayer as default };